import { render, staticRenderFns } from "./OnboardingVerificationUpload.vue?vue&type=template&id=4c40b556&"
import script from "./OnboardingVerificationUpload.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerificationUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports